import { Component, OnDestroy, OnInit, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../../shared.module';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'formly-multiselect-dropdown',
    templateUrl: "./formly-multiselect-dropdown.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, FormlyModule, TranslateModule, SharedModule, NgSelectModule]
})
export class FormlyMultiselectDropdownComponent extends FieldType implements OnInit, OnDestroy {

    param: any;
    isFormSubmitted: boolean = false;
    formSubmissionSubscription: Subscription;
    fieldKey: string;

    constructor(
        private dynamicFormService: DynamicFormService,
        private cdRef: ChangeDetectorRef

    ) {
        super();
    }

    ngOnInit() {
        if (this.field.key) {
            this.fieldKey = this.field.id ?? this.field.key.toString();
        }
        this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
            this.isFormSubmitted = data;
            this.cdRef.detectChanges();
        });
    }

    ngOnDestroy() {
        if (this.formSubmissionSubscription) {
            this.formSubmissionSubscription.unsubscribe();
        }
    }

    onValueChange() {
        if (this.to.change) {
            this.to.change(this.field, this.formControl.value);
        }
    }

    onOpen() {
        setTimeout(() => {
            const scrollContainer = document.querySelector(
                ".ng-dropdown-panel-items"
            );
            if (scrollContainer) {
                scrollContainer.scrollTop = 0;
            }
        }, 0);
    }
}